'use strict';

( function ($) {

    var PAGINATION_TYPE_PAGINATE = 'paginate';
    var PAGINATION_TYPE_LOAD_MORE = 'load_more'; 

    /**
     * @constructor
     */
    function AjaxFilter(options) {
        // ES: Test includes/filter-plugin/ajax-filter.js
        this.options = options || {};
        this.$body = $('body');
        this.$container = $(options.elements.container);
        this.$form = $(options.elements.form);
        this.$resetButton = $(options.elements.reset);
        this.$results = $(options.elements.results);
        this.$pagination = $(options.elements.pagination);
        this.$loading = $(options.elements.loading);
        this.$counters = $(options.elements.counters);
        this.$searchField = $(options.elements.searchField);
        this.baseUrl = this.normalizeUrl(window.location.href);

        this.addEvents();
    }

    $.extend(AjaxFilter.prototype, {
        pageNumber: 1,
        cache: {},
        /**
         * Add event listeners
         */
        addEvents: function () {
            var elements = this.options.elements || {};

            this.$form.on('change', this.initiateFetch.bind(this));

            if (this.options.enableCount) {
                this.$form.on('change', this.fetchCount.bind(this));
            }

            if (elements.pagination) {
                this.$pagination.on('click', 'a', this.onPaginationClick.bind(this));
            }

            if (elements.reset) {
                this.$body.on('click', elements.reset, this.onResetClick.bind(this));
            }

            if (elements.mobileToggle) {
                this.$body.on('click', elements.mobileToggle, this.onMobileToggleClick.bind(this));
            }

            if (elements.searchField) {
                this.$searchField.on('search', this.initiateFetch.bind(this));
                this.$searchField.on('keypress', this.onSearchKeypress.bind(this));

                if (typeof _ !== 'undefined') {
                    this.$searchField.on('keyup', _.debounce(this.initiateFetch.bind(this), 600));
                }
            }
        },
        /**
         * Create request data
         * @return {Object}
         */
        createRequestData: function () {
            var arrayFormat = /\[.*?\]$/;
            var serializeArray = this.$form.serializeArray();
            var data = {};

            // Extend with default parameters
            if (typeof this.options.defaultParameters === 'object') {
                $.extend(data, this.options.defaultParameters);
            }

            // Add support for search field not contained within <form>
            this.$searchField.each(function() {
                if ($(this).closest(this.$form).length === 0) {
                    serializeArray.push({
                        name: $(this).attr('name'),
                        value: $(this).val()
                    });
                }
            });

            // Convert array to object
            serializeArray.forEach(function (input) {
                var key = input.name;
                var value = input.value;

                // Check if array format
                if (arrayFormat.test(key)) {
                    key = key.replace(arrayFormat, '');
                    value = key in data ? data[key].concat(value) : [value];
                }

                if (value !== '') {
                   data[key] = value; 
                }
            });

            return data;

        },
        /**
         * Perform filter mechanic
         * @param {jQuery.event} e
         * @return {Promise}      [description]
         */
        initiateFetch: function(e) {
            if (! this.isConfirmed()) {
                return;
            }

            // When fired from DOM-element (eg. <form> submit or <input> change)
            if (e) {
                this.pageNumber = 1;
            }

            if (this.hasUserFilters()){
                this.$resetButton.show();
            } else {
                this.$resetButton.hide();
            }


            this.show();

            return this.fetchPosts();
        },
        /**
         * Fetch count from AJAX
         */
        fetchCount: function() {
            var self = this;
            var data = this.createRequestData();
            var hash = '';

            // Required parameter for counting
            data.count = 1;

            // Create hash
            hash = $.param(data);

             // Abort possible active XHR request
            if (this.countXhr) {
                this.countXhr.abort();
            }

            // Render directly from cache?
            if (this.options.enableCache && hash in this.cache) {
                this.setCountValues(this.cache[hash].pagination, 'count');
                return;
            }

            // Initiate request
            this.countXhr = $.post(themevars.ajaxurl + '?count=1', data)
                .done(function (response) {
                    // Cache response
                    self.cache[hash] = response.data;

                    // Set counter value
                    self.setCountValues(self.cache[hash].pagination, 'count');
            })
            .fail(function (jqXHR) {
                // error reporting
            })
            .always(function (response) {
                self.countXhr = null;
            });
        },
        /**
         * Fetch posts from AJAX
         * @param {object} data
         * @return {Promise}      [description]
         */
        fetchPosts: function (data) {
            var self = this;
            var data = this.createRequestData();
            var hash = '';
            var $loading = $(this.options.elements.loading);

            // Required parameter for pagination
            if (this.pageNumber) {
                data.paged = this.pageNumber;
            }

            // Required paramaters for paginate links
            if (this.baseUrl) {
                data.base_url = this.baseUrl;
            }

            // Create hash
            hash = $.param(data);

            // Save state to URL
            if (this.options.pushState) {
                this.pushState(data);
            }

            // Abort possible active XHR request
            if (this.xhr) {
                this.xhr.abort();
            }

            // Render directly from cache?
            if (this.options.enableCache && hash in this.cache) {
                this.propagate(this.cache[hash]);
                return $.Deferred().resolve();
            }

            // Set loading state
            if (this.options.loadingClass) {
                $loading.addClass(this.options.loadingClass);
            }

            // Initiate request
            this.xhr = $.post(themevars.ajaxurl, data)
                .done(function (response) {
                    // Render HTML
                    self.propagate(response.data);

                    // Cache response
                    self.cache[hash] = response.data;

                    // Quickfix for Safari (doesn't trigger "always")?
                    if (self.options.loadingClass) {
                        $loading.removeClass(self.options.loadingClass);
                    }
                })
                .always(function (response) {
                    if (self.options.loadingClass) {
                        $loading.removeClass(self.options.loadingClass);
                    }

                    self.xhr = null;
                });

            return this.xhr;
        },
        /**
         * Render HTML from AJAX request
         * @param  {Object} data [description]
         * @return {[type]}      [description]
         */
        propagate: function (data) {
            var empty = '<!-- empty -->';

            // Render HTML
            switch(this.options.pagination) {
                case PAGINATION_TYPE_LOAD_MORE :
                    if (this.pageNumber > 1) {
                        this.loadMoreCounter += data.posts.posts.length
                        this.$results.append(data.posts.html || empty);
                    } else {
                        this.loadMoreCounter = data.posts.posts.length;
                        this.$results.html(data.posts.html || empty);
                    }
                    data.pagination.posts_count = this.loadMoreCounter;
                    break;
                default :
                    if (!this.$body.hasClass('ajax-filter--overlay-open')) {
                        this.$results.html(data.posts.html || empty);
                    }
                    break;
            }
            
            this.$pagination.html(data.pagination.html || empty);

            $(document).trigger('propagate.ajax-filter');

            // Set counters
            this.setCountValues(data.pagination, 'posts');
        },
        /**
         * Set counter values
         * @param Object data
         * @param string action
         */
        setCountValues: function(data, action) {
            
            // Fill counters with value - which should have a data-pagination-property="" attribute 
            this.$counters.each(function () {
                var $el = $(this);
                var property = $(this).data('pagination-property');
                var onlyUpdateOn = $(this).data('pagination-update-on');

                // Limit to certain situations
                if (onlyUpdateOn) {
                    $el = $el.filter('[data-pagination-update-on="' + action + '"]');
                }

                // Check if property exists
                if (property in data) {
                    $el.filter('[data-pagination-property="' + property + '"]').text(data[property]);
                }
            });
        },
        /**
         * Hack to make AJAX fetching work only when confirmed by user
         * @return {Boolean}
         */
        isConfirmed: function() {
            var $confirm = this.$form.find('input[name="confirmed"]');
            var value = $confirm.val();

            // Always mark confirmed when forced
            if (this.forceConfirm) {
                return true;
            }

            // When the element not present - confirmation is not a requirement - so it's confirmed
            if ($confirm.length === 0) {
                return true;
            }

            return value === '1';
        },
        /**
         * Get page index from URL string
         * @param  {[type]} url [description]
         * @return {Number|null}     [description]
         */
        getPageNumberFromUrl: function (url) {
            var matches = url.match(new RegExp(this.options.pageRegex));
            if (matches) {
                return parseInt(matches[1], 10);
            }
            return null;
        },
        /**
         * Normalize URL (Remove query string & hash)
         * @param {String} url
         * @return {String}
         **/
        normalizeUrl: function (url) {
            return url.split('?')[0].split('#')[0];
        },
        /**
         * Prevent overlay opening on <ENTER>
         * @param {jQuery.event}
         */
        onSearchKeypress: function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
            }
        },
        /**
         * Navigate to a page
         * @param  {jQuery.Event} e [description]
         * @return {[type]}   [description]
         */
        onPaginationClick: function (e) {
            var href = $(e.currentTarget).attr('href');

            e.preventDefault();

            switch(this.options.pagination) {
                case PAGINATION_TYPE_LOAD_MORE :
                    this.pageNumber++;
                    break;
                case PAGINATION_TYPE_PAGINATE :
                    $('html, body').animate({scrollTop: 0});
                    this.pageNumber = this.getPageNumberFromUrl(href) || 1;
                    this.baseUrl = this.normalizeUrl(href);
                    break;
            }
            
            this.initiateFetch();
        },
        /**
         * Reset button click
         * @param {jQuery.Event} e
         **/
        onResetClick: function (e) {
            e.preventDefault();
            this.reset();
        },
        /**
         * Remove keys from object
         * @param  {Object} obj  [description]
         * @param  {Array} keys [description]
         * @return {Object}      [description]
         */
        omit: function (obj, keys) {
            var objClean = $.extend({}, obj);
            var blacklist = keys || [];
            for (var key in objClean) {
                if (blacklist.indexOf(key) !== -1) {
                    delete objClean[key];
                }
            }
            return objClean;
        },
        /**
         * Keep keys from object
         * @param  {Object} obj  [description]
         * @param  {Array} keys [description]
         * @return {Object}      [description]
         */
        keep: function (obj, keys) {
            var objClean = $.extend({}, obj);
            var whitelist = keys || [];
            for (var key in objClean) {
                if (whitelist.indexOf(key) === -1) {
                    delete objClean[key];
                }
            }
            return objClean;
        },
        /**
         * Reset filters/state
         **/
        reset: function () {
            // Revert to initial state
            this.$form.trigger('reset');

            // Explicitly reset
            this.$form.find('[type="checkbox"], [type="radio"]').prop('checked', false);
            this.$form.find('[type="text"], [type="search"]').val('');

            // Activate event listeners
            this.$form.trigger('change');

            // Reset functionality for range sliders
            this.$form.find('.range-slider input').trigger('change');

            this.forceConfirm = true;
            this.initiateFetch();
            this.forceConfirm = false;
        },
        /**
         * Add "active" classes to make it visible
         */
        show: function() {
            this.$container.addClass(this.options.cssPrefix + '--active');
            this.$container.removeClass(this.options.cssPrefix + '--inactive');
        },
        /**
         * Add "inactive" classes to make it invisible
         */
        hide: function() {
            this.$container.addClass(this.options.cssPrefix + '--inactive');
            this.$container.removeClass(this.options.cssPrefix + '--active');
        },
        /**
         * Show/hide filters on mobile
         * @param {jQuery.event}
         **/
        onMobileToggleClick: function (e) {
            e.preventDefault();
            
            var bodyClass = [ this.options.cssPrefix + '--overlay-open' ];
            var delayMs;
            if (this.$body.hasClass(bodyClass[0])) {
                delayMs = 300;
                bodyClass.unshift(this.options.cssPrefix + '--open');
            } else {
                delayMs = 10;
                bodyClass.push(this.options.cssPrefix + '--open');
            }
            this.$body.toggleClass(bodyClass.shift());
            this.$container.toggleClass(this.options.cssPrefix + '--overlay');
            setTimeout(() => {
                this.$body.toggleClass(bodyClass.shift());
                if (!$(e.target).hasClass('js-mobile-toggle-no-fetch')) {
                    this.fetchPosts();
                }
            }, delayMs);
        },
        /**
         * User applied (visible) filters
         */
        hasUserFilters() {
            var hasValue = false;
            this.$form.find(':input').each(function() {
                var type = $(this).attr('type') || $(this).prop('tagName');
                switch(type.toLowerCase()) {
                    case 'checkbox' :
                    case 'radio' :
                        hasValue = $(this).prop('checked');
                        break;
                    case 'text' :
                    case 'search' :
                        hasValue = $(this).val() !== '';
                        break;
                }

                if (hasValue === true) {
                    return false;
                }

                // if ($(this).is(':checkbox, :radio') && $(this).prop('checked')) {
                //     hasValue = true;
                // } else if ($(this).is(':checkbox, :radio') && $(this).val() !== '') {
                //     hasValue = true;
                // }
            });
            return hasValue;
        },
        /**
         * Push state to URL
         * @param  {Object} data [description]
         * @return {[type]}
         */
        pushState: function (data) {
            var url = this.baseUrl;
            var filters = this.omit(data, this.options.hiddenParameters);
            var params = '';
            var queryString = '';
            var queryParams = [];

            // Remove page number from filters query (should be in URL instead)
            delete filters.paged;

            params = $.param(filters);

            // Remove page number from URL when it's the first page
            if (this.pageNumber === 1) {
                url = url.replace(new RegExp(this.options.pageRegex), '/');
            }

            // Add support for Wordpress search page
            if (this.options.template === 'search') {
                queryParams.push('s=' + (filters.s || '')); // Add to query string
                url = url.replace(new RegExp(this.options.pageRegex), '/'); // Remove page number
            }

            // Append query string if needed
            if (params) {
                queryParams.push('filter=' + encodeURIComponent(params));
            }

            this.currentState = {
                data: data,
                params: params,
                pageNumber: this.pageNumber
            };

            // Build query string
            if (queryParams.length > 0) {
                queryString = '?' + queryParams.join('&');
            }
            
            // Detect if browser supports pushState
            if (window.history.replaceState) {
                window.history.replaceState(this.currentState, document.title, url + queryString);
            } else {
                window.location.hash = '#' + queryString;
            }
        }

    });

    // Publicly expose AjaxFilter
    window.AjaxFilter = AjaxFilter;

    // Create range slider using noUiSlider
    window.createRangeSlider = function($el) {
        var $slider = $el.find('.range-slider__ui-slider');
        var $input = $el.find('.range-slider__value__input');
        var $minInput = $el.find('.range-slider__value--min .range-slider__value__input');
        var $maxInput = $el.find('.range-slider__value--max .range-slider__value__input');
        var $minAmount = $el.find('.range-slider__value--min .range-slider__value__amount');
        var $maxAmount = $el.find('.range-slider__value--max .range-slider__value__amount');
        var sliderEl = $slider[0];
        var minimum = 1;
        var maximum = 120;

        if (typeof window.noUiSlider === 'undefined') {
            console.error('Couldn\'t locate noUiSlider.');
            return;
        }

        noUiSlider.create(sliderEl, {
            start: [$minInput.val() || minimum, $maxInput.val() || maximum],
            connect: true,
            step: 1,
            margin: 1,
            range: {
                'min': minimum,
                'max': maximum
            }
        });

        // Mark active when initially filled
        if ($minInput.val()) {
            $minInput.prop('checked', true);
        }

        if ($maxInput.val()) {
            $maxInput.prop('checked', true);
        }

        // Reset filter functionality
        $input.on('change', function() {
            if (this.checked === false) {
                sliderEl.noUiSlider.set([
                    sliderEl.noUiSlider.options.range.min,
                    sliderEl.noUiSlider.options.range.max
                ]);
            }
        });

        sliderEl.noUiSlider.on('update', function (values, handle) {
            var value = parseInt(values[handle], 10);
            if (handle === 0) {
                $minAmount.text(value);
            }
            if (handle === 1) {
                $maxAmount.text(value);
            }
        });

        sliderEl.noUiSlider.on('change', function (values, handle) {
            var value = parseInt(values[handle], 10);

            if (handle === 0) {
                $minInput.val(value).prop('checked', true).trigger('change');
            }
            if (handle === 1) {
                $maxInput.val(value).prop('checked', true).trigger('change');
            }
        });
    };

}(jQuery));